import React from "react";
import { Link, useParams } from "react-router-dom";
import { legalPages } from "@/content/legal";
import { Crumbs } from "@/components/NovaKit";

export default function Legal() {
  const { slug } = useParams();
  const page = legalPages[slug];
  if (!page) {
    return (
      <div className="max-w-3xl mx-auto px-6 py-24" data-testid="legal-not-found">
        <h1 className="display text-4xl font-bold mt-6">Legal page not found</h1>
      </div>
    );
  }
  const paragraphs = page.body.split(/\n\n+/);
  return (
    <div data-testid="legal-page" className="border-b hairline">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-14 pt-12 md:pt-16 pb-20">
        <Crumbs trail={[{ label: "Home", to: "/" }, { label: "Legal" }, { label: page.title }]} />
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mt-10">
          <div className="lg:col-span-8">
            <div className="mono text-[11px] tracking-[0.25em] uppercase grad-text font-bold mb-4">12 · Legal</div>
            <h1 className="display text-4xl md:text-5xl font-bold leading-[1.05] mb-4">{page.title}</h1>
            {page.effective && <div className="mono text-[11px] tracking-[0.18em] uppercase text-[#0A0E1A]/55 mb-10">{page.effective}</div>}
            <div className="h-px grad-bg mb-10 max-w-[100px]" />
            <div className="space-y-5 text-[15px] md:text-[16px] leading-[1.8] text-[#0A0E1A]/85 whitespace-pre-line max-w-3xl">
              {paragraphs.map((p, i) => <p key={i}>{p}</p>)}
            </div>
          </div>
          <aside className="lg:col-span-4 lg:pl-8 lg:border-l hairline">
            <div className="mono text-[10px] tracking-[0.25em] uppercase grad-text font-bold mb-6">Legal index</div>
            <ul className="space-y-2">
              {Object.entries(legalPages).map(([k, v]) => (
                <li key={k}>
                  <Link to={`/legal/${k}`}
                    className={"block py-2.5 px-3 rounded-lg text-sm transition-colors " + (k === slug ? "grad-bg text-white font-semibold" : "text-[#0A0E1A]/80 hover:bg-[#F5F6FA]")}>
                    {v.title}
                  </Link>
                </li>
              ))}
            </ul>
          </aside>
        </div>
      </div>
    </div>
  );
}
